import { refreshAndReload } from 'services/auth/actions'
import wechatConstants from '../../shared/constants/wechat'

let _store = null

export function initAuth (store) {
  _store = store
}

export function _redirect (location) {
  const { search, pathname } = location
  const originalUrl = `${pathname}${search}`
  const next = encodeURIComponent(originalUrl)
  window.location.href = `/auth/login?next=${next}`
}

export function requireAuth (location) {
  _store.dispatch(refreshAndReload({ quiet: true })).catch(() => _redirect(location))
}

// Is the user in the middle of signing/loggin up with wechat?
export function isWechatAuthFromCookies (cookies) {
  return cookies.includes(`${wechatConstants.WECHAT_CACHEKEY_COOKIE}=`)
}
